<template>
  <v-overlay :z-index="zIndex" :value="pageLoad">
    <v-progress-circular
      indeterminate
      color="#fff0f2"
      :size="50"
    ></v-progress-circular>
  </v-overlay>
</template>
<script>
export default {
  props: ["pageLoad"],
};
</script>
